import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import FetchContext from 'src/components/fetch-context';
import fetchLists from './lists-query.graphql';
import { AppState } from 'src/reducers';
import { List, Me } from './types';

const OFFSET = 30;

type PageInfo = {
  hasNext: boolean;
};

type IListContext = {
  fetchMoreLists?: () => void;
  moreLists?: List[];
  pageInfo?: PageInfo;
};

const initialContextValue: IListContext = {
  fetchMoreLists: () => undefined,
  moreLists: undefined,
  pageInfo: undefined,
};

const ListContext = createContext<IListContext>(initialContextValue);

export const useListContext = () => useContext(ListContext);

export const ListContextContainer: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IListContext>
>> = props => {
  const fetchContext = useContext(FetchContext);

  const me: Me = useSelector((state: AppState) => state.areas.account.me);

  useEffect(() => {
    if (setPageInfo) setPageInfo(me?.lists.pageInfo);
  }, [me]);

  const [offset, setOffset] = useState<number>(OFFSET);
  const [moreLists, setMoreLists] = useState(undefined);
  const [pageInfo, setPageInfo] = useState<{ hasNext: boolean } | undefined>(
    undefined
  );

  const fetchMoreLists = useCallback(async () => {
    const response = await fetchContext.query(fetchLists, {
      limit: OFFSET,
      offset,
    });
    setMoreLists(response.data.me.lists.nodes);
    setPageInfo(response.data.me.lists.pageInfo);
    setOffset(state => state + OFFSET);
  }, []);

  return (
    <ListContext.Provider value={{ fetchMoreLists, moreLists, pageInfo }}>
      {props.children}
    </ListContext.Provider>
  );
};
